import { useEffect, useState } from "react";
import Link from "next/link";
import sal from "sal.js";
import Image from "next/image";
import LazyImage from "@/my_components/Common/LazyImage";

import AboutTwo from "../../components/Abouts/About-Two";
import InstructorsShowcase from "@/my_components/_HomePage/Home-Sections/InstructorsShowcase";
import BlogGridMinimal from "@/my_components/Blogs/Components/BlogGridMinimal";
import Newsletter_2 from "@/my_components/Newsletters/Newsletter_2";
import { useCountUp } from "@/my_components/Common/useCountUp";

// import Newsletter from "../../my_components/Newsletters/Newsletter";
import { ParallaxProvider, useParallax } from "react-scroll-parallax";

// HOME PAGE SECTIONS
import { getPlatformStats } from "@/services/courseService";

// CONFIGS AND ROUTE
import { ROUTE } from "@/route/app_routes.js";
// import { CONFIG } from "@/app_config.js";

import bookShape from "../../public/images/shape/book-shape-01.png";
import awardImage from "../../public/images/icons/award-gd-01.png";
import cap from "../../public/images/shape/o-icon-2.png";
import coach from "../../public/app_images/about/about_us.webp";
import dots from "../../public/images/shape/a-dot-01.png";


import { image_url } from "../../helper/Utilities";




const SmartTechAcademy = () => {

    const sinceParallax = useParallax({ translateX: [-20, 0] });
    const enrolledParallax = useParallax({ translateX: [30, 0] });
    const [stats, setStats] = useState(null);

    useEffect(() => {
        sal({
            threshold: 0.01,
            once: true,
        });
        getPlatformStats()
            .then((res) => setStats(res.data))
            .catch(() => {});
    }, []);

    // Animate from 0 once the real numbers arrive, rather than snapping straight to them.
    const coursesCount = useCountUp(stats?.total_courses ?? 0, Boolean(stats));
    const studentsCount = useCountUp(stats?.total_students ?? 0, Boolean(stats));

    return (

        <>


            <main className="rbt-main-wrapper">


                
            

                <div className="rbt-banner-area rbt-banner-3 bg-gradient-1 theme-shape header-transperent-spacer"> 
                    <div className="wrapper w-100">
                        <div className="container">
                            <div className="row g-5 justify-content-between align-items-center">
                                <div className="col-lg-6 order-2 order-lg-1">
                                    <div className="content">
                                        <div className="inner">
                                            <div className="section-title text-start">
                                                <span className="subtitle bg-primary-opacity"> SMARTTECH ACADEMY </span>
                                            </div>

                                            <h1 className="title">
                                                Free Tech Education, <span className="theme-gradient">Built for Real</span> Careers &
                                                Training <span className="theme-gradient">Future Experts</span>. </h1>

                                            <div className="rbt-like-total">
                                                <div className="profile-share">
                                                    <div className="more-author-text">
                                                        <h5 className="total-join-students">
                                                            {stats ? `${stats.total_courses}+ free courses, ${stats.total_students}+ learners` : "Join our learners"}
                                                        </h5>
                                                        <p className="subtitle"> Learning real skills, at no cost, from anywhere. </p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="rbt-button-group justify-content-start mt--30">
                                                <Link className="rbt-btn btn-gradient rbt-switch-btn" href="#">
                                                    <span data-text="LET'S TALK ABOUT YOUR PROJECT">LET'S TALK ABOUT YOUR PROJECT</span>
                                                </Link>
                                                <Link className="rbt-btn btn-border rbt-switch-btn" href="#"> <span data-text="FIND COURSES">FIND COURSES</span> </Link>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 order-1 order-lg-2">
                                    <div className="thumbnail-wrapper">
                                        <div className="thumbnail text-end">
                                            <LazyImage src={image_url("/app_images/about/about-hero-collage.webp")} width={597} height={479} alt="SmartTech Academy learners" />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>






















                



                <div className="rbt-about-area bg-color-white rbt-section-gapTop about-style-1">
                    <div className="container">
                        <ParallaxProvider>
                            <AboutTwo />
                        </ParallaxProvider>
                    </div>
                </div>























                <div className="rbt-feature-area rbt-single-course-features rbt-section-gap rbt-feature-box">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-10 offset-lg-1">
                                <div className="row row--30 gy-5 align-items-center">

                                    <div className="col-lg-6 col-xl-5">
                                        <div className="thumbnail rbt-shadow-box">
                                            <LazyImage className="w-100 radius-10" src={image_url("/app_images/services/services.webp")} width={357} height={500} alt="Card image" />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-xl-7" key="1">
                                        <div className="section-title">
                                            <h2 className="title">Why SmartTech Academy</h2>
                                            <p className="b1 mt--15">We believe access to quality tech education shouldn&apos;t depend on your budget. Every course is free, self-paced, and built around real projects &mdash; so what you learn here is what you&apos;ll actually use in a job.</p>
                                        </div>

                                        <div className="section-title subtitle"> <h5 className="title">What you can learn</h5> </div>

                                        <div className="row g-5">
                                            <div className="col-lg-6">
                                                <ul className="rbt-list-style-1">
                                                    <li key="1"> <i className="feather-check"></i> Web Development </li>
                                                    <li key="2"> <i className="feather-check"></i> Mobile App Development </li>
                                                    <li key="3"> <i className="feather-check"></i> Software Engineering </li>
                                                    <li key="4"> <i className="feather-check"></i> Databases & Backend </li>
                                                    <li key="5"> <i className="feather-check"></i> Game Development </li>
                                                </ul>
                                            </div>{" "}
                                            <div className="col-lg-6">
                                                <ul className="rbt-list-style-1">
                                                    <li key="1"> <i className="feather-check"></i> UI/UX Design </li>
                                                    <li key="2"> <i className="feather-check"></i> DevOps & Cloud </li>
                                                    <li key="3"> <i className="feather-check"></i> Data Science & Analysis</li>
                                                    <li key="4"> <i className="feather-check"></i> Frontend Frameworks </li>
                                                    <li key="5"> <i className="feather-check"></i> Programming Fundamentals </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="read-more-btn mt--40">
                                            <Link className="rbt-moderbt-btn" href={ROUTE.course}> <span className="moderbt-btn-text"> Browse Free Courses </span> <i className="feather-arrow-right"></i> </Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


























                <div className="rbt-about-area rbt-section-gap overflow-hidden">
                    <div className="about-style-4 version-04">
                        <div className="shape-2">
                            <LazyImage src={bookShape} width={1393} height={956} unoptimized={true} alt="Shape" />
                        </div>

                        <div className="container">
                            <div className="row row--60 mt_dec--40 align-items-center">

                                <div className="col-xl-5 col-12 mt--40">
                                    <div className="about-thumb">
                                        <div className="shape-1">
                                            <LazyImage src={dots} width={87} height={140} unoptimized={true} alt="Shape" />
                                        </div>

                                        <div className="since" ref={sinceParallax.ref}>
                                            <span>
                                                <Image src={awardImage} width={36} height={51} alt="Award Icon" />
                                            </span>
                                            <div className="title-wrap">
                                                <h4 className="number">
                                                    <span className="odometer rbt-font-primary">
                                                        {coursesCount}
                                                    </span>
                                                </h4>
                                                <h6 className="subtitle">Free Courses</h6>
                                            </div>
                                        </div>

                                        <div className="enrolled" ref={enrolledParallax.ref}>
                                            <div className="enrolled-cont">
                                                <span><Image src={cap} width={41} height={31} alt="image" /></span>
                                                <div>
                                                    <h6 className="enrolled-title d-flex align-items-center">
                                                        <span className="odometer rbt-font-primary"> {studentsCount} </span>
                                                        +
                                                    </h6>
                                                    <p className="enrolled-description"> Students Learning </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="thumb-1">
                                            <LazyImage src={coach} width={474} height={662} alt="A SmartTech Academy learner" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-12 mt--40">
                                    <div className="content">
                                        <div className="section-title">
                                            <span className="subtitle bg-primary-opacity">
                                                About SmartTech
                                            </span>
                                            <h2 className="title w-600">
                                                We Help People Discover Their True Potential.
                                            </h2>
                                        </div>
                                        <p className="mt--20">
                                            At SmartTech Academy, we believe cost should never be the
                                            reason someone can&apos;t learn to code. Every course is free,
                                            self-paced, and built to prepare you for a real tech career.
                                        </p>
                                        <ul className="mt--30 mb--25">
                                            <li>
                                                <span className="icon bg-primary-opacity">
                                                    <i className="feather-heart"></i>
                                                </span>
                                                <span className="text">Flexible Classes</span>
                                            </li>
                                            <li>
                                                <span className="icon bg-secondary-opacity">
                                                    <i className="feather-book"></i>
                                                </span>
                                                <span className="text">Learn From Anywhere</span>
                                            </li>
                                        </ul>
                                        <div className="d-flex align-items-center gap-5 flex-wrap">
                                            <Link className="rbt-btn btn-gradient hover-icon-reverse" href={ROUTE.contact}>
                                                <span className="icon-reverse-wrapper">
                                                    <span className="btn-text">Contact Us</span>
                                                    <span className="btn-icon">
                                                        <i className="feather-arrow-right"></i>
                                                    </span>
                                                    <span className="btn-icon">
                                                        <i className="feather-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


























                <div className="rbt-call-to-action-area rbt-section-gap bg-color-secondary-alt">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rbt-cta-6 text-center">
                                    <div className="content">
                                        <h1 className="title"> {"Ready to start"}
                                        <br /> learning for free? </h1>
                                        <p>No cost, no catch &mdash; just real courses.</p>
                                        <div className="rbt-button-group justify-content-center">
                                            <Link className="rbt-btn btn-gradient" href={ROUTE.register}> Join for Free </Link>
                                            <Link className="rbt-btn btn-border" href={ROUTE.course}> Browse Courses </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>











                <div className="rbt-instructor-area bg-color-white rbt-section-gap">
                    <div className="container">
                        <div className="row mb--60">
                            <div className="col-lg-12 text-center">
                                <div className="section-title">
                                    <span className="subtitle bg-primary-opacity">Who&apos;s Teaching</span>
                                    <h2 className="title">Meet your instructors</h2>
                                    <p className="description mt--20">
                                        Real engineers who&apos;ve shipped production code, teaching the fundamentals they use every day.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <InstructorsShowcase />
                    </div>
                </div>











                <div className="rbt-ready-area ready-section-01 rbt-section-gap bg_image" style={{ backgroundImage: `url(${image_url('/app_images/bg/bg_img.jpg')})` }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <span className="subtitle bg-primary-opacity"> Ready to start? </span>
                                    <h2 className="title w-600">Your tech career starts with lesson one</h2>
                                    <p className="mt--10 description"> Every course is free, self-paced, and built around real projects &mdash; <br />{" "} pick one and start today. </p>
                                    <Link className="rbt-btn btn-gradient hover-icon-reverse" href={ROUTE.course}>
                                        <span className="icon-reverse-wrapper">
                                            <span className="btn-text">Browse Courses</span>
                                            <span className="btn-icon">
                                                <i className="feather-arrow-right"></i>
                                            </span>
                                            <span className="btn-icon">
                                                <i className="feather-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>










                <div className="rbt-rbt-blog-area rbt-section-gapTop bg-gradient-8 rbt-round-bottom-shape">
                    <div className="wrapper pb--50 rbt-index-upper">
                        <div className="container">
                            <div className="row g-5 align-items-end mb--60">
                                <div className="col-lg-6 col-md-12 col-12">
                                    <div className="section-title text-start">
                                    <h2 className="title color-white">Latest News</h2>
                                    <p className="description color-white-off mt--20">
                                        Free, structured courses built around real projects — learn skills that translate directly into a tech career.
                                    </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 col-12">
                                    <div className="load-more-btn text-start text-lg-end">
                                        <a className="rbt-btn btn-border icon-hover radius-round color-white-off" href={ROUTE.blog}>
                                            <span className="btn-text">See All Articles</span>
                                            <span className="btn-icon"><i className="feather-a~rrow-right"></i></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <BlogGridMinimal />
                        </div>
                    </div>
                </div>






                <div className="rbt-newsletter-area bg-color-white rbt-section-gapBottom pt--60">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Newsletter_2 />
                            </div>
                        </div>
                    </div>
                </div>








                {/* <div className="rbt-newsletter-area bg-color-primary newsletter-style-2 rbt-section-gap" 
                style={{ background: "url("+image_url('../app_images/bg/dots.png')+") repeat center/auto" }}>
                <Newsletter />
                </div> */}


            </main>

        </>
    );
  
};



export default SmartTechAcademy;
